/** Our cached data. Comes with expiration time to validate if it should still be used. Default is that objects never expire. */
export class CacheObject<T> {

  public Data: T;
  public AbsoluteExpirationDate?: Date;

  constructor(opt?: Partial<CacheObject<T>>) {
    Object.assign(this, opt);
  }

}
